export default __webpack_public_path__ + "static/media/userPlaceholder.77d7ec1d.jpg";